import { useEffect, useState } from 'react';
import { connect } from '@evertrue/et-flux';
import InteractionSource from 'apps/interactions/sources/interaction-source';
import InteractionStore from 'apps/interactions/stores/interaction-store';
import CachedContactStore from 'apps/contact/stores/cached-contact-store';
import InteractionTable from '../components/interaction-table';
import PropTypes from 'prop-types';

const mapStateToProps = () => ({
  contacts: CachedContactStore.getAllContacts(),
});

/**
 * Controller component that manages interaction data and state
 *
 * Acts as a bridge between Flux stores and the InteractionFeed component.
 * Handles loading interactions into the store and managing contact data
 * updates. Provides clean props interface for the feed component.
 * If you're reading this, this is Perry, the developer of this monstrosity, sorry!
 */
const InteractionFeedController = (props) => {
  const [interactions, setInteractions] = useState([]);
  const [contactDataVersion, setContactDataVersion] = useState(0);

  // Load interactions into the store when props change
  useEffect(() => {
    InteractionSource.loadInteractions(props.interactions);
  }, [props.interactions]);

  // Get interactions from store and update local state
  useEffect(() => {
    const ids = props.interactions ? props.interactions.map((interaction) => interaction.id) : [];
    setInteractions(InteractionStore.getInteractions(ids));
  }, [props.interactions, contactDataVersion]);

  // Listen for contact data changes by watching the contacts prop from the store
  useEffect(() => {
    setContactDataVersion((prev) => prev + 1);
  }, [props.contacts]);

  return <InteractionTable {...props} notes={interactions} />;
};

InteractionFeedController.propTypes = {
  className: PropTypes.string,
  interactions: PropTypes.array,
  group: PropTypes.bool,
  loading: PropTypes.bool,
  highlight: PropTypes.string,
  showContact: PropTypes.bool,
  showFullText: PropTypes.bool,
  showMessage: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  // Pagination props
  total: PropTypes.number,
  page: PropTypes.number,
  limit: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  sortProp: PropTypes.string,
  sortReverse: PropTypes.bool,
  onSort: PropTypes.func,
  // Flux store props
  contacts: PropTypes.object,
};

export default connect(InteractionFeedController, [CachedContactStore], mapStateToProps);
